import _classCallCheck from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/pager/pages/page_index_selector.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["defaultPageIndex", "hasKnownLastPage", "isLargeDisplayMode", "maxPagesCount", "pageCount", "pageIndex", "pageIndexChange", "pagesCountText", "showNavigationButtons", "totalCount"];
import { createFragment, createComponentVNode } from "inferno";
import { Fragment } from "inferno";
import { BaseInfernoComponent } from "@devextreme/vdom";
import { LightButton } from "../common/light_button";
import { PagesLarge } from "./large";
import { PagesSmall } from "./small";
import { PagerProps } from "../common/pager_props";
import { ConfigContext } from "../../../common/config_context";
var PAGER_NAVIGATE_BUTTON = "dx-navigate-button";
var PAGER_PREV_BUTTON_CLASS = "dx-prev-button";
var PAGER_NEXT_BUTTON_CLASS = "dx-next-button";
export var PAGER_BUTTON_DISABLE_CLASS = "dx-button-disable";
var nextButtonClassName = "".concat(PAGER_NAVIGATE_BUTTON, " ").concat(PAGER_NEXT_BUTTON_CLASS);
var prevButtonClassName = "".concat(PAGER_NAVIGATE_BUTTON, " ").concat(PAGER_PREV_BUTTON_CLASS);
var nextButtonDisabledClassName = "".concat(PAGER_BUTTON_DISABLE_CLASS, " ").concat(PAGER_NAVIGATE_BUTTON, " ").concat(PAGER_NEXT_BUTTON_CLASS);
var prevButtonDisabledClassName = "".concat(PAGER_BUTTON_DISABLE_CLASS, " ").concat(PAGER_NAVIGATE_BUTTON, " ").concat(PAGER_PREV_BUTTON_CLASS);
export var viewFunction = function viewFunction(_ref) {
  var navigateToNextPage = _ref.navigateToNextPage,
      navigateToPrevPage = _ref.navigateToPrevPage,
      nextClassName = _ref.nextClassName,
      pageIndexChange = _ref.pageIndexChange,
      prevClassName = _ref.prevClassName,
      _ref$props = _ref.props,
      isLargeDisplayMode = _ref$props.isLargeDisplayMode,
      maxPagesCount = _ref$props.maxPagesCount,
      pageCount = _ref$props.pageCount,
      pageIndex = _ref$props.pageIndex,
      pagesCountText = _ref$props.pagesCountText,
      renderNextButton = _ref.renderNextButton,
      renderPrevButton = _ref.renderPrevButton;
  return createFragment([renderPrevButton && createComponentVNode(2, LightButton, {
    className: prevClassName,
    label: "Previous page",
    onClick: navigateToPrevPage
  }), isLargeDisplayMode && createComponentVNode(2, PagesLarge, {
    maxPagesCount: maxPagesCount,
    pageCount: pageCount,
    pageIndex: pageIndex,
    pageIndexChange: pageIndexChange
  }), !isLargeDisplayMode && createComponentVNode(2, PagesSmall, {
    pageCount: pageCount,
    pageIndex: pageIndex,
    pageIndexChange: pageIndexChange,
    pagesCountText: pagesCountText
  }), renderNextButton && createComponentVNode(2, LightButton, {
    className: nextClassName,
    label: "Next page",
    onClick: navigateToNextPage
  })], 0);
};

function getIncrement(direction) {
  return "next" === direction ? 1 : -1;
}

export var PageIndexSelectorProps = {
  isLargeDisplayMode: true
};
var PageIndexSelectorPropsType = {
  maxPagesCount: PagerProps.maxPagesCount,
  pageCount: PagerProps.pageCount,
  hasKnownLastPage: PagerProps.hasKnownLastPage,
  showNavigationButtons: PagerProps.showNavigationButtons,
  totalCount: PagerProps.totalCount,
  isLargeDisplayMode: PageIndexSelectorProps.isLargeDisplayMode,
  defaultPageIndex: PagerProps.pageIndex
};
export var PageIndexSelector =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(PageIndexSelector, _BaseInfernoComponent);

  function PageIndexSelector(props) {
    var _this;

    _classCallCheck(this, PageIndexSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageIndexSelector).call(this, props));
    _this._currentState = null;
    _this.state = {
      pageIndex: void 0 !== _this.props.pageIndex ? _this.props.pageIndex : _this.props.defaultPageIndex
    };
    _this.getNextDirection = _this.getNextDirection.bind(_assertThisInitialized(_this));
    _this.getPrevDirection = _this.getPrevDirection.bind(_assertThisInitialized(_this));
    _this.canNavigateToPage = _this.canNavigateToPage.bind(_assertThisInitialized(_this));
    _this.getNextPageIndex = _this.getNextPageIndex.bind(_assertThisInitialized(_this));
    _this.canNavigateTo = _this.canNavigateTo.bind(_assertThisInitialized(_this));
    _this.navigateToPage = _this.navigateToPage.bind(_assertThisInitialized(_this));
    _this.pageIndexChange = _this.pageIndexChange.bind(_assertThisInitialized(_this));
    _this.navigateToNextPage = _this.navigateToNextPage.bind(_assertThisInitialized(_this));
    _this.navigateToPrevPage = _this.navigateToPrevPage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PageIndexSelector, [{
    key: "set_pageIndex",
    value: function set_pageIndex(value) {
      var _this2 = this;

      this.setState(function (state) {
        var _this$props$pageIndex, _this$props;

        _this2._currentState = state;
        var newValue = value();
        null === (_this$props$pageIndex = (_this$props = _this2.props).pageIndexChange) || void 0 === _this$props$pageIndex ? void 0 : _this$props$pageIndex.call(_this$props, newValue);
        _this2._currentState = null;
        return {
          pageIndex: newValue
        };
      });
    }
  }, {
    key: "getNextDirection",
    value: function getNextDirection() {
      var _this$config;

      return !(null !== (_this$config = this.config) && void 0 !== _this$config && _this$config.rtlEnabled) ? "next" : "prev";
    }
  }, {
    key: "getPrevDirection",
    value: function getPrevDirection() {
      var _this$config2;

      return !(null !== (_this$config2 = this.config) && void 0 !== _this$config2 && _this$config2.rtlEnabled) ? "prev" : "next";
    }
  }, {
    key: "canNavigateToPage",
    value: function canNavigateToPage(pageIndex) {
      if (!this.props.hasKnownLastPage) {
        return pageIndex >= 0;
      }

      return pageIndex >= 0 && pageIndex <= this.props.pageCount - 1;
    }
  }, {
    key: "getNextPageIndex",
    value: function getNextPageIndex(direction) {
      return this.__state_pageIndex + getIncrement(direction);
    }
  }, {
    key: "canNavigateTo",
    value: function canNavigateTo(direction) {
      return this.canNavigateToPage(this.getNextPageIndex(direction));
    }
  }, {
    key: "navigateToPage",
    value: function navigateToPage(direction) {
      this.pageIndexChange(this.getNextPageIndex(direction));
    }
  }, {
    key: "pageIndexChange",
    value: function pageIndexChange(pageIndex) {
      if (this.canNavigateToPage(pageIndex)) {
        this.set_pageIndex(function () {
          return pageIndex;
        });
      }
    }
  }, {
    key: "navigateToNextPage",
    value: function navigateToNextPage() {
      this.navigateToPage(this.getNextDirection());
    }
  }, {
    key: "navigateToPrevPage",
    value: function navigateToPrevPage() {
      this.navigateToPage(this.getPrevDirection());
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props, {
          pageIndex: this.__state_pageIndex
        }),
        config: this.config,
        renderPrevButton: this.renderPrevButton,
        renderNextButton: this.renderNextButton,
        nextClassName: this.nextClassName,
        prevClassName: this.prevClassName,
        pageIndexChange: this.pageIndexChange,
        navigateToNextPage: this.navigateToNextPage,
        navigateToPrevPage: this.navigateToPrevPage,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "config",
    get: function get() {
      if ("ConfigContext" in this.context) {
        return this.context.ConfigContext;
      }

      return ConfigContext;
    }
  }, {
    key: "__state_pageIndex",
    get: function get() {
      var state = this._currentState || this.state;
      return void 0 !== this.props.pageIndex ? this.props.pageIndex : state.pageIndex;
    }
  }, {
    key: "renderPrevButton",
    get: function get() {
      var _this$props2 = this.props,
          isLargeDisplayMode = _this$props2.isLargeDisplayMode,
          showNavigationButtons = _this$props2.showNavigationButtons;
      return !isLargeDisplayMode || showNavigationButtons;
    }
  }, {
    key: "renderNextButton",
    get: function get() {
      return this.renderPrevButton || !this.props.hasKnownLastPage;
    }
  }, {
    key: "nextClassName",
    get: function get() {
      var direction = this.getNextDirection();
      var canNavigate = this.canNavigateTo(direction);
      return canNavigate ? nextButtonClassName : nextButtonDisabledClassName;
    }
  }, {
    key: "prevClassName",
    get: function get() {
      var direction = this.getPrevDirection();
      var canNavigate = this.canNavigateTo(direction);
      return canNavigate ? prevButtonClassName : prevButtonDisabledClassName;
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props$pageIndex2 = _extends({}, this.props, {
        pageIndex: this.__state_pageIndex
      }),
          restProps = _objectWithoutPropertiesLoose(_this$props$pageIndex2, _excluded);

      return restProps;
    }
  }]);

  return PageIndexSelector;
}(BaseInfernoComponent);
PageIndexSelector.defaultProps = _extends({}, PageIndexSelectorPropsType);